export class LoginBackground {
  logo: string;
  topShape: string;
  bottomShape: string;
}
